import { Component } from '@angular/core';

@Component({
  selector: 'ow-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

}
